module.exports = __webpack_public_path__ + "static/media/device0.63616ae5.svg";


//////////////////
// WEBPACK FOOTER
// ./public/image/device0.svg
// module id = 20
// module chunks = 0